import { PerkDefinition } from "./types";

/**
 * Boss Heal perk - Stronger version of Adrenaline.
 * Heals 3 HP per stack when taking damage.
 */
export const perkBossHeal = {
  id: "perk_boss_heal",
  name: "Boss Heal",
  description: "When you take damage, heal 3 HP.",
  apply: () => {
    // No stat modifications on apply
  },
  onDamageTaken: (_damageAmount, context) => {
    // Heal 3 HP per stack when taking damage
    return context.stackCount * 3;
  },
} satisfies PerkDefinition<"perk_boss_heal">;
